import { Fragment } from 'react';
import PropertiesFormDependentSection from './PropertiesFormDependentSection';
import useNewPropertiesForm from './useNewPropertiesForm';
import { useEffect } from 'react';
import { PropertiesProvider } from '../context/PropertiesProvider';
import { useStableFunction } from '../utils/hooks/useStableFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function NewPropertiesForm({
  onStatusChange: onStatusChangeUnstable,
  enableAutosave = false,
  enableFieldLevelPermissions = true,
  alwaysShowConditionalProperties,
  alwaysShowConditionalPropertyOptionsWithErrors,
  fetchConditionalPropertyRules,
  inputMode,
  objectId,
  objectTypeId,
  onChange,
  onSave,
  properties,
  values,
  renderInput,
  renderDependentSection,
  renderProps,
  resetRef,
  showPropertyDescription,
  getSavedValue
}) {
  const {
    inputs,
    status,
    reset
  } = useNewPropertiesForm({
    alwaysShowConditionalProperties,
    alwaysShowConditionalPropertyOptionsWithErrors,
    enableAutosave,
    fetchConditionalPropertyRules,
    inputMode,
    objectId,
    objectTypeId,
    onChange,
    onSave,
    properties,
    values,
    showPropertyDescription,
    getSavedValue
  });
  if (resetRef) {
    resetRef.current = reset;
  }
  const onStatusChange = useStableFunction(onStatusChangeUnstable);
  useEffect(() => {
    onStatusChange(status);
  }, [status, onStatusChange]);
  const passthroughProps = Object.assign({}, renderProps);
  function renderDependents(dependents, path) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: dependents.map(dependent => /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          "data-test-id": `${path}-${dependent.property.name}`,
          children: renderInput ? renderInput(dependent) : dependent.render(passthroughProps)
        }), renderDependents(dependent.dependents, `${path}-${dependent.property.name}`)]
      }, `${path}-${dependent.property.name}`))
    });
  }
  return /*#__PURE__*/_jsx(PropertiesProvider, {
    enableFieldLevelPermissions: enableFieldLevelPermissions,
    children: inputs.map(input => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        "data-test-id": input.property.name,
        children: renderInput ? renderInput(input) : input.render(passthroughProps)
      }), input.dependents.length > 0 && (renderDependentSection ? renderDependentSection(input, passthroughProps) : /*#__PURE__*/_jsx(PropertiesFormDependentSection, {
        property: input.property,
        children: renderDependents(input.dependents, input.property.name)
      }))]
    }, input.property.name))
  });
}